var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHilbiAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35AE019C-ACE8-4344-9394-D0334D140612") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Patients-Modal2",
    transform: "translate(-705.000000, -463.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(371.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(178.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alex-perez-570754-unsplash",
    transform: "translate(150.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Hilbi-2",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Hilbi"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#6AD5E5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.580322154,8.58032933 C-0.193440718,9.35350838 -0.193440718,10.6079217 0.580322154,11.3811007 L0.580322154,11.3811007 L8.61879273,19.4196707 C9.39196222,20.1934431 10.64636,20.1934431 11.4201229,19.4196707 L11.4201229,19.4196707 C12.1932924,18.6458982 12.1932924,17.3914849 11.4201229,16.6177125 L11.4201229,16.6177125 L3.38224568,8.58032933 C2.99477087,8.19344311 2.48802739,8 1.98128392,8 L1.98128392,8 C1.47394707,8 0.96720359,8.19344311 0.580322154,8.58032933",
    id: "Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58035085,0.579728778 C7.80654972,1.35408503 7.80654972,2.60788943 8.58035085,3.38165231 L8.58035085,3.38165231 L16.6192189,11.4201229 C17.3924267,12.1932924 18.6462931,12.1932924 19.4200942,11.4201229 L19.4200942,11.4201229 C20.1933019,10.64636 20.1933019,9.39196222 19.4200942,8.61879273 L19.4200942,8.61879273 L11.3812261,0.579728778 C10.9943256,0.193440718 10.487557,0 9.98078849,0 L9.98078849,0 C9.47401995,0 8.96725142,0.193440718 8.58035085,0.579728778",
    id: "Fill-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58589187,8.58595769 C7.80470271,9.3672346 7.80470271,10.6332148 8.58589187,11.4144917 L8.58589187,11.4144917 C9.36648195,12.1951694 10.632919,12.1951694 11.4141081,11.4144917 L11.4141081,11.4144917 C12.1952973,10.6332148 12.1952973,9.3672346 11.4141081,8.58595769 L11.4141081,8.58595769 C11.0235136,8.19531923 10.5119065,8 9.99970046,8 L9.99970046,8 C9.48809346,8 8.97648645,8.19531923 8.58589187,8.58595769",
    id: "Fill-22"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHilbiAvatar);
export default __webpack_public_path__ + "static/media/hilbi-avatar.dabf29464dd3f9d47c657b25900ef133.svg";
export { ForwardRef as ReactComponent };